<template>
  <div class="box10">
    <div class="title">
      <p>班主任、讲师、技术导师、就业导师</p>
      <p>四位一体，各环节无缝衔接</p>
      助力高质量、高效率完成学习
    </div>

    <div class="content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block" :class="'block' + (index + 1)">
            <div class="tit">
              {{ item.title }}
              <span>{{ item.tag }}</span>
            </div>

            <img
              class="tag"
              :src="
                require(`../../assets/architect/box10/tag${
                  index + 1
                }.png`)
              "
              alt
            />

            <div
              class="text"
              v-for="(item1, index1) in item.text"
              :key="index1"
            >
              <div class="p1">
                <img
                  class="icon1"
                  :src="
                    require(`../../assets/architect/box10/icon${
                      index + 1
                    }.png`)
                  "
                  alt
                />
                {{ item1.p1 }}
              </div>
              <div class="p2">{{ item1.p2 }}</div>
            </div>
          </div>
          <div class="seat" v-show="index == 2"></div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="btn" @click="childMethod">查看更多服务</div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",

        pagination: {
          el: ".swiper-pagination-box10",
        },
      },
      list: [
        {
          title: "课前",
          tag: "BEFORE CLASS",
          text: [
            {
              p1: "前置课程",
              p2: "领取课程大纲及学习路径图",
            },
            {
              p1: "学籍信息",
              p2: "建立学员档案，确定学习目标",
            },
            {
              p1: "入学测试",
              p2: "技术摸底测试，面谈技术导师",
            },
            {
              p1: "班主任全程督学",
              p2: "跟踪服务，全程指导",
            },
          ],
        },
        {
          title: "课中",
          tag: "IN CLASS",
          text: [
            {
              p1: "录播课程教学",
              p2: "倍速观看学习内容，提高学习效率",
            },
            {
              p1: "社群集结",
              p2: "高质量学习社群，集结大厂人脉",
            },
            {
              p1: "源码资料",
              p2: "配套所有文档资料源码，方便课后复习使用",
            },
            {
              p1: "作业实战",
              p2: "技术导师根据课程难易程度，配置课后实战",
            },
          ],
        },
        {
          title: "课后",
          tag: "AFTER CLASS",
          text: [
            {
              p1: "就业指导",
              p2: "陪跑式就业咨询答疑，高质量就业资源提供",
            },
            {
              p1: "简历指导",
              p2: "帮你打造完美简历，提高就职竞争力",
            },
            {
              p1: "模拟面试",
              p2: "真实面试情景演练，十足把握面试场景",
            },
            {
              p1: "技术生态圈",
              p2: "课程定期迭代更新，了解行业热门知识",
            },
          ],
        },
      ],
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  },
};
</script>

<style lang="less" scoped>
.box10 {
  padding: 80px 0px 88px;
  width: 100%;
  background: #e5f0ff;
  .btn{
    width: 400px;
    height: 78px;
    font-size: 34px;
    color: #fff;
    text-align: center;
    line-height: 78px;
    border-radius: 14px;
    background: #ff5627;
    margin: 50px auto 0;
  }
  .title {
    margin-bottom: 48px;
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    font-weight: bold;
    line-height: 62px;
    text-align: center;
    color: #24375c;
  }

  .content {
    position: relative;
  }

  .swiper-slide {
    width: auto;
    flex-shrink: 0;
    display: flex;
  }
  .seat {
    width: 32px;
    flex-shrink: 0;
  }
  .block {
    padding-left: 32px;
    padding-right: 50px;
    padding-top: 40px;
    // width: 474px;
    min-width: 392px;
    height: 488px;
    background-color: #f9fffe;
    border-radius: 20px;
    border: solid 1px #95ffed;
    // box-sizing: border-box;
    .tit {
      display: flex;
      align-items: end;
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      font-weight: bold;
      color: #101010;
      span {
        margin-left: 10px;
        font-family: PingFang SC;
        font-size: 22px;
        font-weight: normal;
        letter-spacing: 1px;
        color: #9fc2bc;
      }
    }

    .text {
      margin-bottom: 20px;
      font-family: PingFangSC-Medium;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 38px;
      letter-spacing: 0px;
      color: #101010;
      img {
        margin-right: 10px;
        width: 24px;
        height: 24px;
      }
      .p2 {
        font-family: PingFang SC;
        font-weight: 300;
        text-indent: 40px;
        white-space: nowrap;
      }
    }

    .tag {
      margin-bottom: 25px;
      margin-top: 5px;
      width: 286px;
      height: 8px;
    }
  }

  .block2 {
    background: #fffcf9;
    border: solid 1px #ffc57c;
    .tit {
      span {
        color: #e6c9ac;
      }
    }
  }

  .block3 {
    background: #fcf8f8;
    border: solid 1px #fab19b;
    .tit {
      span {
        color: #e6b6b6;
      }
    }
  }

  .swiper-pagination-box10 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    width: 60px;
    height: 6px;

    // background: #70c3f7;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }
  .swiper-slide {
    margin-left: 32px;
  }
  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
    opacity: 1;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #57a3f5;
    border-radius: 3px;
  }
}
</style>
